export default "__VITE_ASSET__hncls71s__"